import { IExportColumnModel } from "../../../../shared/models";

export const StaqEventsColumnList: IExportColumnModel[] = [
]